<sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none"
  *ngIf="restrictionSimulatorForm.get('accountNumber').value && (isAccountNumberInvalid || isAccountNumberLengthInvalid)">
  <div class="sdps-notification__text" id="sdpsErrorNotificationText">
    <p>{{emtrConstant.rulesConstant.pleaseCorrectFollowingError}}</p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li>{{accountNumberErrorMessage}}</li>
    </ul>
  </div>
</sdps-notification>

<sdps-notification type="error" class="sdps-m-top_none" *ngIf="securitySearchText && showSecuritySearchNoRecords">
  <div class="sdps-notification__text">
    <p>{{emtrConstant.rulesConstant.pleaseCorrectFollowingError}}</p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li>{{emtrConstant.rulesConstant.autoComplete.noRecords}}</li>
    </ul>
  </div>
</sdps-notification>

<sdps-notification type="information" class="sdps-m-top_none" *ngIf="!(emtrService.clientInformation | async)?.orgId">
  <p class="sdps-notification__text" [innerHTML]="emtrConstant.rulesConstant.ruleGlobalConst.noCientSelected"></p>
</sdps-notification>

<div *ngIf="(emtrService.clientInformation | async)?.orgId">
  <h2 class="page-title sdps-m-bottom_large sdps-display-inline-block" [innerHTML]="emtrConstant.restrictionSimulator.restrictionSimulatorText"></h2>
  <span class="sdps-m-horizontal_large sdps-m-bottom_medium sdps-display-inline-block client-selection-indicator"
    [ngClass]="(emtrService.clientInformation | async)?.businessUnit | lowercase"
    [innerHTML]="(emtrService.clientInformation | async)?.k4ClientName">
  </span>

  <div class="step-border-box sdps-p-around_large">
    <p class="sdps-text-l-bold-body sdps-m-bottom_large" [innerHTML]="emtrConstant.restrictionSimulator.accountInformationTitle"></p>
    <form [formGroup]="restrictionSimulatorForm">
      <div class="sdps-row restriction-simulator-account-row">
        <div class="col-6 restriction-simulator-account-field">
          <div class="ems-input link-input-textbox"
            [ngClass]="{'invalidField': (restrictionSimulatorForm.get('accountNumber').value && (isAccountNumberInvalid || isAccountNumberLengthInvalid))}">
            <p-floatlabel variant="in">
              <input id="restriction-simulator-account-number" type="text" formControlName="accountNumber" maxlength="10"
                emsAccountNumberFormat (focusout)="validateAccountNumber()"
                [ariaLabel]="accountNumberFieldLabel" pInputText class="w-100-per" />
              <label for="restriction-simulator-account-number">{{accountNumberFieldLabel}}<em class="highlight-color">*</em></label>
            </p-floatlabel>
          </div>
        </div>

        <div class="col-6 restriction-simulator-master-accounts-field">
          <div class="ems-input link-input-textbox">
            <ems-multiselect id="restriction-simulator-master-accounts" [highlightColor]="true" [singleSelect]="false"
              [label]="emtrConstant.restrictionSimulator.masterAccountsLabel" [searchable]="false" [options]="masterAccountOptions"
              [showAllWhenAllSelected]="true" [selectedCountThreshold]="2" formControlName="masterAccounts" [disabled]="isMasterAccountDisabled">
            </ems-multiselect>
          </div>
        </div>
      </div>

      <div class="restriction-simulator-section-divider" aria-hidden="true"></div>

      <div class="restriction-simulator-trade-orders-layout sdps-m-bottom_large">
        <div class="restriction-simulator-trade-orders-left">
          <p class="sdps-text-l-bold-body sdps-m-around_none restriction-simulator-trade-orders-title">{{emtrConstant.restrictionSimulator.tradeOrdersTitle}}</p>

          <div class="restriction-simulator-security-search-holder">
            <div class="auto-complete common-data-table restriction-simulator-security-search"
              [ngClass]="{ 'restriction-simulator-security-search-disabled': isSecurityLimitReached }">
              <label class="sr-only" for="restriction-simulator-security-search-input">{{emtrConstant.restrictionSimulator.securitySearchLabel}}</label>
              <p-autoComplete [(ngModel)]="securitySearchText" [ngModelOptions]="{ standalone: true }" (ngModelChange)="clearValidationMessages()"
                [suggestions]="securitySearchResults" (completeMethod)="autocompleteSecuritySearch($event)" [minLength]="1"
                inputId="restriction-simulator-security-search-input" [ariaLabel]="emtrConstant.restrictionSimulator.securitySearchLabel"
                  [placeholder]="securitySearchPlaceholder"
                [disabled]="isSecurityLimitReached" class="auto-complete-list" (onSelect)="selectedSecurityValue($event)">
                <ng-template let-search pTemplate="item">
                  <span class="search-symbol">{{search?.id || search?.tickerSymbol || search?.symbol}}</span>
                  <span class="search-desc">{{search?.name || search?.description}}</span>
                </ng-template>
              </p-autoComplete>
              <em class="pi pi-search"></em>
            </div>
          </div>
        </div>

        <div class="restriction-simulator-trade-orders-right">
          <div class="restriction-simulator-trade-orders">
            <div class="restriction-simulator-dropdown-field">
              <p-floatlabel variant="in">
                <p-dropdown id="restriction-simulator-order-type" [options]="orderTypeOptions" optionLabel="label" optionValue="value"
                  formControlName="orderType" [appendTo]="'body'" [style]="{ width: '100%' }" [ariaLabel]="emtrConstant.restrictionSimulator.orderTypeFieldLabel"
                  styleClass="restriction-simulator-dropdown">
                </p-dropdown>
                <label for="restriction-simulator-order-type">{{emtrConstant.restrictionSimulator.orderTypeFieldLabel}}</label>
              </p-floatlabel>
            </div>

            <div class="restriction-simulator-dropdown-field">
              <p-floatlabel variant="in">
                <p-dropdown id="restriction-simulator-security-type" [options]="isThematicOrder ? [] : securityTypeOptions" optionLabel="label" optionValue="value"
                  formControlName="securityType" [appendTo]="'body'" [style]="{ width: '100%' }" [ariaLabel]="emtrConstant.restrictionSimulator.securityTypeFieldLabel"
                  [disabled]="isThematicOrder"
                  [styleClass]="isThematicOrder ? 'restriction-simulator-dropdown restriction-simulator-dropdown-centered' : 'restriction-simulator-dropdown'">
                </p-dropdown>
                <label for="restriction-simulator-security-type">{{emtrConstant.restrictionSimulator.securityTypeFieldLabel}}</label>
              </p-floatlabel>
            </div>
          </div>
        </div>
      </div>

      <ems-table-record-count [count]="selectedSecurities.length" [showRecords]="false" [showTotalForSecurities]="true" [showHeaderIcons]="false"></ems-table-record-count>

      <p-table
        [columns]="selectedSecuritiesTableColumns"
        [value]="selectedSecurities"
        class="common-data-table restriction-simulator-selected-table"
        [sortOrder]="1"
        sortMode="multiple"
        [scrollable]="isThematicOrder"
        [scrollHeight]="isThematicOrder ? '375px' : null"
        [attr.aria-label]="emtrConstant.restrictionSimulator.selectedSecuritiesTableAriaLabel">
        <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
          <span class="pi" [ngClass]="{
                                'pi-sort': sortOrder === 0,
                                'pi-caret-down': sortOrder === 1,
                                'pi-caret-up': sortOrder === -1,
                              }"></span>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field !== 'remove' && col.field !== 'action' ? col.field : ''"
              [ngClass]="selectedSecurities.length > 1 && col.field !== 'remove' && col.field !== 'action' ? 'pointer-events-auto' : 'pointer-events-none'">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="selectedSecurities.length > 1 && col.field !== 'remove' && col.field !== 'action'"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="sdps-text-center">{{emtrConstant.rulesConstant.autoComplete.noSecuritiesSelected}}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-security let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'action'">
                  <p-dropdown [id]="'restriction-simulator-action-' + rowIndex" [(ngModel)]="security.action" (ngModelChange)="clearValidationMessages()"
                    [ngModelOptions]="{ standalone: true }" [options]="resolveTradeActionOptions(security)" optionLabel="label" optionValue="value"
                    [ariaLabel]="emtrConstant.restrictionSimulator.tradeActionAriaLabel" [disabled]="isThematicOrder" [appendTo]="'body'"
                    styleClass="restriction-simulator-action-dropdown">
                  </p-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="'remove'">
                  <button type="button" class="restriction-simulator-remove-btn" (click)="removeSelectedSecurity(rowIndex)" [attr.aria-label]="emtrConstant.restrictionSimulator.removeSecurityAriaLabel">
                    <em class="pi pi-times" aria-hidden="true"></em>
                  </button>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <span>{{security[col.field]}}</span>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <sdps-notification type="confirmation" class="restriction-simulator-result-notification restriction-simulator-result-notification-allowed" [ngClass]="{ 'restriction-simulator-notification-expanded': isValidationSummaryExpanded }" *ngIf="validationSummaryStatus === 'ALLOWED'">
        <div class="sdps-notification__text">
          <p class="restriction-simulator-summary-text">
            <strong>{{validationSummaryLabel}}</strong>
            <span> - {{validationAllowedSummaryDescription}}</span>
          </p>
        </div>
      </sdps-notification>

      <sdps-notification type="error" class="restriction-simulator-result-notification restriction-simulator-result-notification-restricted" [ngClass]="{ 'restriction-simulator-notification-expanded': isValidationSummaryExpanded }" *ngIf="validationSummaryStatus === 'RESTRICTED'">
        <div class="restriction-simulator-summary-content" [ngClass]="{ 'restriction-simulator-summary-content-expanded': isValidationSummaryExpanded }">
          <div class="sdps-notification__text">
            <p class="restriction-simulator-summary-text">
              <strong>{{validationSummaryLabel}}</strong>
              <span *ngIf="showValidationSummaryDescription"> - {{validationSummaryDescription}}</span>
            </p>
          </div>
          <button type="button" class="restriction-simulator-details-link" *ngIf="showValidationDetailsToggle" (click)="toggleValidationDetails()">
            {{viewDetailsExpanded ? 'Hide Details' : 'View Details'}}
          </button>
        </div>
      </sdps-notification>

      <div class="restriction-simulator-details-container sdps-m-top_x-small" *ngIf="viewDetailsExpanded && validationDetailRows.length">
        <ng-container *ngFor="let row of validationDetailRows">
          <sdps-notification type="error" class="restriction-simulator-detail-notification restriction-simulator-detail-notification-restricted" [ngClass]="{ 'restriction-simulator-notification-expanded': isValidationDetailExpanded(row.message) }" *ngIf="row.status === 'RESTRICTED'; else allowedDetailRow">
            <div class="sdps-notification__text">
              <p class="restriction-simulator-detail-text">
                <strong>{{row.tickerSymbol}} — {{row.status}}</strong>
                <span> {{row.message}}</span>
              </p>
            </div>
          </sdps-notification>

          <ng-template #allowedDetailRow>
            <sdps-notification type="confirmation" class="restriction-simulator-detail-notification restriction-simulator-detail-notification-allowed" [ngClass]="{ 'restriction-simulator-notification-expanded': isValidationDetailExpanded(row.message) }">
              <div class="sdps-notification__text">
              <p class="restriction-simulator-detail-text">
                <strong>{{row.tickerSymbol}} — {{row.status}}</strong>
                <span> {{row.message}}</span>
              </p>
              </div>
            </sdps-notification>
          </ng-template>
        </ng-container>
      </div>
    </form>

    <div *ngIf="hasRestrictionSimulatorActionAccess" class="sdps-row sdps-m-top_small restriction-simulator-action-spacer"></div>

    <div *ngIf="hasRestrictionSimulatorActionAccess" class="sdps-row sdps-m-top_small restriction-simulator-action-row">
      <div class="col">
        <span class="sdps-pull-right">
          <button class="buttons" type="button" (click)="clearRestrictionSimulatorForm()">{{emtrConstant.ruleFilter.clearButton}}</button>
          <button class="buttons button-save" type="button" [disabled]="!canSubmitRestrictionSimulator || isSubmittingRestrictionSimulator" (click)="onSubmitRestrictionSimulator()">{{emtrConstant.submitButton}}</button>
        </span>
      </div>
    </div>
    <p class="sdps-clearfix no-margin"></p>
  </div>
</div>
